export enum NotificationType {
  Airnote = 'airnote',
  TriggerEvent = 'air-trigger-event'
}
